import { defaultBrowserDevBridgeUrl } from '@renderer/lib/browser-dev-bridge';
import { getWebConsoleApiBaseUrl, isWebConsoleMode } from '@renderer/lib/web-console-api';

function isElectronRenderer(): boolean {
  return typeof window !== 'undefined' && window.navigator.userAgent.toLowerCase().includes('electron');
}

function getBrowserBridgeUrl(): string {
  if (typeof window === 'undefined') {
    return defaultBrowserDevBridgeUrl;
  }

  return window.alttvisionBrowserDevBridgeUrl ?? defaultBrowserDevBridgeUrl;
}

export function getAssetPreviewUrl(assetId: string | null | undefined): string | null {
  if (!assetId) {
    return null;
  }

  if (isElectronRenderer()) {
    return `av-asset://asset/${assetId}`;
  }

  if (isWebConsoleMode()) {
    return `${getWebConsoleApiBaseUrl()}/assets/${encodeURIComponent(assetId)}`;
  }

  return `${getBrowserBridgeUrl()}/assets/${encodeURIComponent(assetId)}`;
}
